import { Platform } from '@angular/cdk/platform';
import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { debounceTime, exhaustMap, map, of } from 'rxjs';

/**
 *  Check auth guard
 *
 * @returns
 */
export const checkAuthGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    return authService.session.pipe(
        exhaustMap((session) => {
            if (!session) {
                return authService.isAuthenticated();
            }
            return of(true);
        }),
        debounceTime(0),
        map(() => {
            return true;
        })
    );
};

/**
 *  Check auth and open dialog if not authenticated
 *
 * @param route
 * @returns
 */
export const authGuard: CanActivateFn = (route) => {
    const { authCheck } = route.data;
    const authService = inject(AuthService);
    const router = inject(Router);
    const isServer = !inject(Platform).isBrowser;

    return authService.session.pipe(
        debounceTime(10),
        exhaustMap((isAuthenticated) => {
            if (!isAuthenticated && authCheck && !isServer) {
                return authService.openSignInDialog();
            }

            return of(true);
        }),
        map((isAuthenticated) => {
            if (!isAuthenticated && !router.lastSuccessfulNavigation && !isServer) {
                router.navigate(['/']);
                return false;
            }
            return isAuthenticated;
        })
    );
};

export const authChildGuard: CanActivateChildFn = () => {
    const router = inject(Router);
    const authService = inject(AuthService);

    return authService.session.pipe(
        map((session) => {
            if (!session) {
                router.navigate(['/']);
                return false;
            }
            return true;
        })
    );
};
